module.exports = __webpack_public_path__ + "static/media/image1.e0b5f169.webp";